<div
	class="announcementCard"
	cdkDrag
	mat-ripple
	[cdkDragData]="{item: media, index: index}"
	[cdkDragDisabled]="!isDraggable"
	[class.usedWithinPresentationCommander]="usedWithinPresentationCommander"
	[class.active]="active"
	(click)="showPreviewButton ? mediaClicked.emit(media) : mediaWasClicked()"
>
	<div class="upperContent" [class.noFileTypeIcon]="!showFileTypeIcon">
		@if (showFileTypeIcon) {
			<div class="fileTypeDisplay" [class.noMediaPreview]="!showPreview">
				@if (previewMedia ? previewMediaType === MediaType.PDF : media?.mediaType === MediaType.PDF) {
					<i class="fad fa-file-pdf"></i>
				}
				@if (previewMedia ? previewMediaType === MediaType.PowerPoint : media?.mediaType === MediaType.PowerPoint) {
					<i class="fad fa-file-powerpoint"></i>
				}
				@if (previewMedia ? previewMediaType === MediaType.Excel : media?.mediaType === MediaType.Excel) {
					<i class="fad fa-file-excel"></i>
				}
				@if (previewMedia ? previewMediaType === MediaType.Image : media?.mediaType === MediaType.Image) {
					<i class="fad fa-file-image"></i>
				}
				@if (previewMedia ? previewMediaType === MediaType.Video : media?.mediaType === MediaType.Video) {
					<i class="fad fa-file-video"></i>
				}
				@if (previewMedia ? previewMediaType === MediaType.Audio : media?.mediaType === MediaType.Audio) {
					<i class="fad fa-file-audio"></i>
				}
			</div>
		}

		@if (previewMedia ? previewMediaType === MediaType.Audio : media?.mediaType === MediaType.Audio) {
			<button
				mat-mini-fab
				color="accent"
				[class.isUploadingMedia]="isUploading"
				class="vogPlayButton"
				[disabled]="mediaPlayer?.webSocket?.activityState === ActivityState.Inactive"
			>
				<sim-animated-material-icon
					[trigger]="active"
					[endIcon]="{
						fontSet: 'fad',
						fontIcon: 'fa-pause',
						themeColor: 'accent',
					}"
					[startIcon]="{
						fontSet: 'fad',
						fontIcon: 'fa-play',
						themeColor: 'white',
					}"
				/>
			</button>
		}

		@if (isUploading) {
			<mat-progress-spinner
				class="uploadProgreessSpinner"
				[color]="'accent'"
				diameter="40"
				mode="determinate"
				[value]="uploadProgress"
			/>
		}

		@if (showPreview) {
			@if (previewMedia ? previewMediaType === MediaType.Image : media.mediaType === MediaType.Image) {
				<div
					class="imgPreview"
					appStopPropagation
					(click)="openImageInDialog()"
					[style.backgroundImage]="
						previewMedia ? 'url(' + previewMediaUrl + ')' : 'url(' + simUtilityService.getMediaPath(media, 60) + ')'
					"
				></div>
			}
			@if (previewMedia ? previewMediaType === MediaType.PDF : media.mediaType === MediaType.PDF) {
				<div
					class="pdfPreview"
					appStopPropagation
					(click)="openPDFInDialog()"
					[matTooltip]="
						pdfLoaded
							? (T.MEDIA_CARD_OPEN_PDF_DIALOG | translate)
							: pdfLoadingError
								? (T.MEDIA_CARD_PDF_LOADING_ERROR | translate)
								: (T.MEDIA_CARD_PDF_LOADING | translate)
					"
					[matTooltipClass]="pdfLoaded ? 'accent' : pdfLoadingError ? 'warn' : 'accent'"
				>
					@if (!pdfLoadingError || pdfLoaded) {
						<sim-document-viewer
							[media]="media"
							[isPreviewMedia]="previewMedia"
							[previewMediaUrl]="previewMediaUrl"
							(pdfLoadingError)="pdfLoadingError = $event"
							(pdfLoaded)="pdfLoaded = $event"
							[pageNum]="pagePos"
						/>
					}
					@if (pdfLoadingError) {
						<div class="error">
							<i class="fad fa-times fa-2x"></i>
						</div>
					}
					@if (!pdfLoaded && !pdfLoadingError) {
						<div class="loader">
							<i class="fa-spin fad fa-circle-notch"></i>
						</div>
					}
					@if (!pdfLoaded) {
						<mat-icon
							fontSet="fad"
							fontIcon="fa-file-pdf"
							inline
							[class.loadingFile]="!pdfLoaded"
							class="fileIcon"
							style="font-size: 2em; height: unset; position: absolute"
						/>
					}
				</div>
			}
			@if (previewMedia ? previewMediaType === MediaType.PowerPoint : media.mediaType === MediaType.PowerPoint) {
				<div
					class="powerPointViewer"
					appStopPropagation
					(click)="openPowerPointDialog()"
					[matTooltip]="
						powerPointLoaded
							? (T.MEDIA_CARD_OPEN_POWERPOINT_DIALOG | translate)
							: pptxLoadingError
								? (T.MEDIA_CARD_POWERPOINT_LOADING_ERROR | translate)
								: (T.MEDIA_CARD_POWER_POINT_LOADING | translate)
					"
					[matTooltipClass]="powerPointLoaded ? 'accent' : pptxLoadingError ? 'warn' : 'accent'"
				>
					<sim-presentation-viewer
						[media]="media"
						[file]="currentSelectedFile"
						[width]="60"
						[height]="60"
						[pageNum]="pagePos"
						(loadingError)="pptxLoadingError = $event"
						(loaded)="powerPointLoaded = $event"
					/>
					@if (pptxLoadingError) {
						<div class="error">
							<i class="fad fa-times fa-2x"></i>
						</div>
					}
					@if (!powerPointLoaded && !pptxLoadingError) {
						<div class="loader">
							<i class="fa-spin fad fa-circle-notch"></i>
						</div>
					}
					@if (!powerPointLoaded) {
						<mat-icon
							fontSet="fad"
							fontIcon="fa-file-powerpoint"
							class="fileIcon"
							inline
							[class.loadingFile]="!powerPointLoaded"
							style="font-size: 2em; height: unset; position: absolute"
						/>
					}
				</div>
			}
			@if (previewMedia ? previewMediaType === MediaType.Video : media.mediaType === MediaType.Video) {
				<div class="videoPreview" appStopPropagation (click)="openVideoDialog()">
					<video
						[src]="previewMedia ? previewMediaUrl : simUtilityService.getMediaPath(media)"
						style="width: 100%; position: absolute"
						preload="metadata"
					></video>
				</div>
			}
		}

		<div class="announcementCardText">
			@if (media) {
				<div class="announcementCardTitle">
					{{ media?.name }}
				</div>
			}

			@if (media) {
				<div class="announcementCardFilePath">
					{{ media?.fileName }}
				</div>
			}

			@if (!media && previewMedia) {
				<div class="mediaFilePreviewText" appStopPropagation>
					<mat-form-field color="accent">
						<mat-label>{{ T.SHARED_MEDIA_CARD_LIST_MEDIA_NAME | translate }}</mat-label>
						<input
							type="text"
							(blur)="mediaNameChanged()"
							[disabled]="!mediaInEditMode"
							matInput
							[(ngModel)]="mediaName"
							[matTooltip]="errorMessage"
						/>
						@if (!!errorMessage) {
							<mat-error>
								{{ errorMessage }}
							</mat-error>
						}
					</mat-form-field>
				</div>
			}
		</div>

		@if (showLoopButton) {
			<button
				(click)="toggleVogMediaLooping.emit(media)"
				[class.active]="isLooping"
				appStopPropagation
				class="repeatButton"
				color="accent"
				mat-icon-button
				matTooltip="{{ T.SHARED_MEDIA_CARD_REPEAT_MEDIA | translate }}"
				matTooltipClass="accent"
			>
				<mat-icon fontIcon="fa-repeat" fontSet="far" inline />
			</button>
		}

		@if (previewMedia) {
			<button
				matTooltip="{{ T.SHARED_MEDIA_CARD_LIST_EDIT_META_DATA | translate }}"
				matTooltipClass="accent"
				mat-icon-button
				color="accent"
				appStopPropagation
				(click)="mediaNameChanged()"
			>
				<sim-animated-material-icon
					[trigger]="mediaInEditMode"
					[biggerFAIcon]="true"
					[endIcon]="{fontSet: 'fad', fontIcon: 'fa-save'}"
					[startIcon]="{
						fontSet: 'fad',
						fontIcon: 'fa-edit',
						themeColor: 'accent',
					}"
				/>
			</button>
		}

		@if (showDeleteButton) {
			<button
				matTooltip="{{ (useRemoveIcon ? T.SHARED_MEDIA_CARD_LIST_REMOVE : T.SHARED_MEDIA_CARD_LIST_DELETE) | translate }}"
				matTooltipClass="accent"
				mat-icon-button
				color="warn"
				appStopPropagation
				(click)="deleteButtonClicked.emit()"
			>
				@if (useRemoveIcon) {
					<i style="font-size: 1.2em" class="fas fa-minus"></i>
				} @else {
					<i style="font-size: 1.2em" class="fad fa-trash-alt"></i>
				}
			</button>
		}

		@if (showDownloadButton) {
			<button
				matTooltip="{{ T.SHARED_MEDIA_CARD_LIST_DOWNLOAD_MEDIA | translate }}"
				matTooltipClass="accent"
				mat-icon-button
				color="accent"
				appStopPropagation
				(click)="downloadMedia()"
			>
				<i style="font-size: 1.2em" class="fas fa-download"></i>
			</button>
		}

		@if (showEditButton) {
			<button
				matTooltip="{{ T.SHARED_MEDIA_CARD_LIST_EDIT_MEDIA | translate }}"
				matTooltipClass="accent"
				mat-icon-button
				color="accent"
				appStopPropagation
				(click)="editButtonClicked.emit()"
			>
				<mat-icon fontSet="fad" fontIcon="fa-edit" inline style="font-size: 1.2em" />
			</button>
		}

		@if (showAddButton) {
			<button
				matTooltip="{{ T.SHARED_MEDIA_CARD_LIST_ADD_MEDIA | translate }}"
				matTooltipClass="accent"
				mat-icon-button
				color="accent"
				appStopPropagation
				(click)="addButtonClicked.emit()"
			>
				<mat-icon fontSet="fa" fontIcon="fa-plus" inline style="font-size: 1.2em" />
			</button>
		}

		@if (showPreviewButton) {
			<button mat-raised-button color="accent" appStopPropagation (click)="mediaWasClicked()">
				{{ T.SHARED_MEDIA_CARD_LIST_PREVIEW_FILE | translate }}
			</button>
		}

		@if (presentationControls && (media.mediaType === MediaType.PDF || media.mediaType === MediaType.PowerPoint)) {
			<button
				mat-icon-button
				color="accent"
				(click)="backwardClicked.emit()"
				appStopPropagation
				matTooltip="{{ T.SHARED_MEDIA_CARD_LIST_PREV_MEDIA_FILE | translate }}"
				matTooltipClass="accent"
			>
				<mat-icon fontSet="fad" style="font-size: 1.2em" fontIcon="fa-backward" inline />
			</button>
		}

		@if (presentationControls && (media.mediaType === MediaType.PDF || media.mediaType === MediaType.PowerPoint)) {
			<button
				mat-icon-button
				color="accent"
				(click)="forwardClicked.emit()"
				appStopPropagation
				matTooltip="{{ T.SHARED_MEDIA_CARD_LIST_NEXT_MEDIA_FILE | translate }}"
				matTooltipClass="accent"
			>
				<mat-icon fontSet="fad" style="font-size: 1.2em" fontIcon="fa-forward" inline />
			</button>
		}

		@if (presentationControls) {
			<button
				mat-icon-button
				color="warn"
				(click)="stopMedia.emit()"
				appStopPropagation
				matTooltip="{{ T.SHARED_MEDIA_CARD_LIST_STOP_MEDIA_FILE | translate }}"
				matTooltipClass="warn"
			>
				<mat-icon fontSet="fad" style="font-size: 1.2em" fontIcon="fa-stop" inline />
			</button>
		}

		@if (isDraggable) {
			<button
				cdkDragHandle
				appStopPropagation
				mat-icon-button
				matTooltip="{{ T.DRAG_AND_DROP | translate }}"
				matTooltipClass="accent"
				color="accent"
			>
				<mat-icon fontSet="fad" fontIcon="fa-arrows" inline />
			</button>
		}

		@if (active && media?.mediaType !== MediaType.Image) {
			<div class="progressBar">
				<mat-progress-bar color="accent" mode="determinate" [value]="getProgress" />
			</div>
		}
	</div>

	@if (currentAudioChannels?.length > 1 && settings.audioDeviceMode !== AudioDeviceMode.Pure) {
		<div class="selection" appStopPropagation>
			<mat-chip-listbox aria-label="VOG Speaker Selection" appStopPropagation multiple>
				@for (audioChannel of currentAudioChannels | orderBy: "displayName"; track audioChannel) {
					<mat-chip-option
						color="accent"
						(selectionChange)="handleAudioChannelSelection(media, audioChannel, $event)"
						[selected]="selectedAudioChannelIds?.includes(audioChannel.id)"
					>
						{{ audioChannel.displayName }}
					</mat-chip-option>
				}
			</mat-chip-listbox>
		</div>
	}
</div>
